export const div = ["MW", "CO", "DM", "SA", "RA"];

export const classifWork = ["Project", "Department Work", "Other"];
